<template>
  <v-flex v-if="errors && errors.length">
    <v-alert
      v-for="(error, i) of errorsParsed"
      :key="i"
      class="mt-0 mb-1"
      dismissible
      :color="error.color"
      tile
      :value="true"
      @click="clearError(i)"
    >
      {{ error.message }}
    </v-alert>
    <v-snackbar
      v-for="(error, i) of errorsParsed"
      :key="error + i"
      :light="error.color === 'warning'"
      class="ft-error-snackbar"
      :timeout="5000"
      :color="error.color"
      :value="i === 0"
    >
      {{ error.message }}
      <v-btn
        class="mr-2"
        icon
        :dark="error.color === 'error'"
        text
        @click="clearError(i)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-flex>
</template>

<script>
export default {
  name: 'ApiErrors',

  props: {
    errors: Array
  },

  data: function () {
    return {
      hideErrors: []
    }
  },

  computed: {
    /**
     * Converts a combined Array of String/Object errors to a consistent
     * Array of error message+color Objects
     */
    errorsParsed () {
      return this.errors?.map(e => {
        let error = {message: e, color: 'error'}
        if (e.toString()?.startsWith(':WARN:')) {
          error.message = e.substring(6)
          error.color = 'warning'
        }
        return error
      })
    }
  },

  methods: {
    clearError (index) {
      this.errors.splice(index, 1)
    }
  }
}
</script>
